import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { isPublic: true, title: '' },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/Register.vue'),
    meta: { isPublic: true, title: '' },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPassword.vue'),
    meta: { isPublic: true, title: '' },
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
      },
      {
        path: '/product/:id',
        name: 'Product',
        component: () => import('../views/Product.vue'),
      },
      {
        path: '/hotel/:id',
        name: 'Hotel',
        component: () => import('../views/Hotel.vue'),
      },
      {
        path: '/user',
        name: 'User',
        component: () => import('../views/User.vue'),
      },
      {
        path: '/paysuccess',
        name: 'PaySuccess',
        component: () => import('../views/pay/Success.vue'),
      },
      {
        path: '/payfail',
        name: 'PayFail',
        component: () => import('../views/pay/Fail.vue'),
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 }
  },
})

export default router
